import { render, staticRenderFns } from "./RegisterInput.vue?vue&type=template&id=0bcba8dc&scoped=true&"
import script from "./RegisterInput.vue?vue&type=script&lang=js&"
export * from "./RegisterInput.vue?vue&type=script&lang=js&"
import style0 from "./RegisterInput.vue?vue&type=style&index=0&id=0bcba8dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcba8dc",
  null
  
)

export default component.exports